var map = {
	"./AstroismScreen.png": 9813,
	"./BetterDoctorScreen.png": 5588,
	"./CosmicCrawlersScreen.png": 6370,
	"./GTWebDevPlatformScreen.png": 4680,
	"./IdealCourseMappingScreen.png": 4345,
	"./JuniorMarketScreen.png": 9252,
	"./MyExpenseScreen.png": 5709,
	"./SpaceInvadersScreen.png": 415,
	"./TimeWarpScreen.png": 2994,
	"./UGAMarketPlaceScreen.png": 129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7111;